module.exports = __webpack_public_path__ + "static/img/IMG_20160925_192514.442a21a9.jpg";